import React from "react";
import moment from "moment";
import styles from "../PreviewV3.module.css";

export default function DocumentAuthorizationSection({ sectionData, displayName, sectionNumber, targetId }) {
  const safeSectionData = sectionData || {};

  const approvers = safeSectionData.approvers || [];
  const visibleApprovers = approvers.filter((approver) => {
    const role = approver && approver.role ? approver.role.toLowerCase().trim() : "";
    const isCreator = role === "creator";
    const hasSignature = approver && approver.signature && `${approver.signature}`.trim() !== "";
    return isCreator || hasSignature;
  });

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        {safeSectionData.notes && (
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: safeSectionData.notes || "" }}></div>
        )}
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Action</th>
              <th>Date</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {visibleApprovers.length === 0 ? (
              <tr>
                <td colSpan={6} className={styles.PreviewTableEmpty}>No approvers available</td>
              </tr>
            ) : visibleApprovers.map((approver, index) => (
              <ApproverRow key={index} approver={approver} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const ApproverRow = ({ approver }) => {
  const safeApprover = approver || {};

  return (
    <tr>
      <td><strong>{safeApprover.name}</strong></td>
      <td style={{ textTransform: "capitalize" }}>{safeApprover.position}</td>
      <td>{safeApprover.phone_number}</td>
      <td>{safeApprover.action}</td>
      <td>{moment.utc(safeApprover.date).format("DD/MM/YYYY")}</td>
      <td>{safeApprover.signature ? (
        <img style={{ maxWidth: "auto", objectFit: "contain", maxHeight: "20px" }} src={safeApprover.signature} alt="Signature" />
      ) : "-"}</td>
    </tr>
  )
}